import React from 'react';
import {
    IconMailCheckXXL,
    IconTeamXXL,
    IconEyeHideXXL,
    IconAnonymousXXL,
    IconPresentXXL,
    IconRocketXXL,
} from '../../../../icons';
import css from './SectionMainBenefits.css';

export default () => (
    <div className={css.grid}>
        <div className={css.gridItem}>
            <IconMailCheckXXL />
            <h3>Anfragen akzeptieren</h3>
            <p>
                Akzeptiere Anfragen, um Mitgliedern antworten zu können.{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://support.horsedeal.com/hc/de/articles/27386985127314/"
                >
                    Mehr erfahren
                </a>
            </p>
        </div>
        <div className={css.gridItem}>
            <IconPresentXXL />
            <h3>Match schenken</h3>
            <p>
                Übernehme die Credits für das Akzeptieren deiner Anfrage.{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://support.horsedeal.com/hc/de/articles/27387157273618/"
                >
                    Mehr erfahren
                </a>
            </p>
        </div>
        <div className={css.gridItem}>
            <IconTeamXXL />
            <h3>Ansichten aufdecken</h3>
            <p>
                Finde heraus, wer dein Reiter- oder Pferde-Profil angesehen hat.{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://support.horsedeal.com/hc/de/articles/27387087763090/"
                >
                    Mehr erfahren
                </a>
            </p>
        </div>
        <div className={css.gridItem}>
            <IconEyeHideXXL />
            <h3>Unsichtbar bleiben</h3>
            <p>
                Vollständige Unsichtbarkeit in der Suche, der Karte und bei Ansichten.{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://support.horsedeal.com/hc/de/articles/27387051412114/"
                >
                    Mehr erfahren
                </a>
            </p>
        </div>
        <div className={css.gridItem}>
            <IconAnonymousXXL />
            <h3>Anonym suchen</h3>
            <p>
                Namen, Fotos und Videos bleiben bis zu einem Match verborgen.{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://support.horsedeal.com/hc/de/articles/27387130476050"
                >
                    Mehr erfahren
                </a>
            </p>
        </div>
        <div className={css.gridItem}>
            <IconRocketXXL />
            <h3>Sichtbarkeit erhöhen</h3>
            <p>
                Erhöhe deine Sichtbarkeit und erhöhe deine Chancen auf ein Match.{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://support.horsedeal.com/hc/de/articles/27387135344274/"
                >
                    Mehr erfahren
                </a>
            </p>
        </div>
    </div>
);
